<template>
  <div class="circuit-breaker">
    <MainBackButton />
    <p
      class="subtitle is-4 has-text-left"
      style="padding-top: 15px; margin-bottom: 2px"
    >
      <span style="padding-left: 60px">Circuit-Breaker Delivery</span>
    </p>

    <div class="container">
      <div class="notification">
        <div class="field has-addons order">
          <div class="control">
            <a class="button is-outlined">
              <i class="fa fa-phone" />
            </a>
          </div>
          <div class="control is-expanded">
            <input
              class="input is-info"
              v-model="phoneNumber"
              type="number"
              placeholder="Your WhatsApp Number"
            />
          </div>
        </div>

        <div style="padding-bottom: 6px">
          <label class="label has-text-link">New Delivery</label>
        </div>

        <!-- pickup -->
        <div class="field has-addons order">
          <div class="control">
            <a class="button is-outlined field-name">Pickup</a>
          </div>
          <div class="control is-expanded">
            <input
              class="input is-info"
              v-model="pickup"
              type="text"
              placeholder="Address or Postcode"
            />
          </div>
          <div class="control" @click="lookupAddress('pickup')">
            <a
              class="button has-text-weight-medium is-outlined"
              style="width: 35px"
            >
              <i class="fa fa-map-marker-alt" />
            </a>
          </div>
        </div>

        <!-- dropoff -->
        <div class="field has-addons order">
          <div class="control">
            <a class="button is-outlined field-name">Dropoff</a>
          </div>
          <div class="control is-expanded">
            <input
              class="input is-info"
              v-model="dropoff"
              type="text"
              placeholder="Address or Postcode"
            />
          </div>
          <div class="control" @click="lookupAddress('dropoff')">
            <a
              class="button has-text-weight-medium is-outlined"
              style="width: 35px"
            >
              <i class="fa fa-map-marker-alt" />
            </a>
          </div>
        </div>

        <!-- time -->
        <div class="field has-addons order">
          <div class="control">
            <a class="button is-outlined field-name">
              <i class="far fa-clock" />&nbsp;Time
            </a>
          </div>
          <div class="control is-expanded">
            <input
              class="input is-info"
              v-model="time"
              type="text"
              placeholder="ASAP or 1900"
            />
          </div>
        </div>

        <!-- offer -->
        <div class="field has-addons order">
          <div class="control">
            <a class="button is-outlined field-name">
              <i class="fa fa-dollar-sign" />&nbsp;Offer
            </a>
          </div>
          <div class="control is-expanded">
            <input
              class="input is-info"
              v-model="offer"
              type="number"
              placeholder="Amount for Driver"
            />
          </div>
        </div>

        <!-- item -->
        <div class="field has-addons order">
          <div class="control">
            <a class="button is-outlined field-name">
              <i class="fa fa-shopping-bag" />&nbsp;Item
            </a>
          </div>
          <div class="control is-expanded">
            <input
              class="input is-info"
              v-model="item"
              type="text"
              placeholder="Item Description"
            />
          </div>
        </div>

        <!-- comments -->
        <div class="field">
          <div class="control">
            <textarea
              class="textarea is-primary"
              v-model="notes"
              placeholder="📝 Delivery Notes"
              rows="2"
            ></textarea>
          </div>
        </div>

        <div class="field">
          <div class="control">
            <button
              class="button is-success is-fullwidth"
              v-clipboard:copy="shortLinkMessage()"
              @click="preSubmit"
              :disabled="!this.phoneNumber"
            >
              Share Delivery Job
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import EventBus from "../eventBus";
// import geo from "@/geo";
import MainBackButton from "@/components/MainBackButton.vue";

const shortid = require("shortid");

export default {
  name: "CircuitBreaker",
  components: {
    MainBackButton,
  },
  data() {
    return {
      phoneNumber: null,
      pickup: null,
      dropoff: null,
      time: null,
      offer: null,
      item: null,
      notes: null,
      pickupAddress: null,
      dropoffAddress: null,
      link: shortid.generate(), // short code
    };
  },
  computed: {},
  methods: {
    invalidForm() {
      if (!this.pickup || !this.dropoff || !this.time || !this.offer) {
        this.$swal({
          type: "warning",
          title: "Invalid Form",
          text: "Please fill in all the fields",
        });
        return true;
      }
      return false;
    },
    shareMessage() {
      if (!this.pickupAddress || !this.dropoffAddress) {
        return;
      }
      var p = this.pickupAddress;
      var d = this.dropoffAddress;
      return `Delivery Job 🎉
📍Pickup: ${p.postcode}, ${p.street}
📍Dropoff: ${d.postcode}, ${d.street}
🕐Time: ${this.time}
🛍Item: Carousell purchase in bag <4kg
Vehicle: 🛵 or 🚗
💰Offer: $${this.offer}
👉🏼Click to bid `;
    },
    preSubmit() {
      if (this.invalidForm()) return;
      if (!this.pickupAddress || !this.dropoffAddress) {
        this.warningAlert("Please check the addresses first");
        return;
      }
      this.submit();
      // check distance to user and other checks
      //   var dist = geo.distanceToUserInMeters(dropoff, userLoc);
      //   this.$swal({
      //     html: `You seem far away from the delivery address, are you sure it's correct?<br><br>
      //     ${this.addressName} is ${dist} meters from your current location.`,
      //     confirmButtonText: "Yes, that's right",
      //     cancelButtonText: this.$t("try-again"),
      //     showCancelButton: true
      //   }).then(val => {
      //     if (val.value) this.submit();
      //   });
    },
    // https://developers.onemap.sg/commonapi/search?searchVal=268276&returnGeom=Y&getAddrDetails=Y&pageNum=1
    lookupAddress(type) {
      var postcode = this.pickup;
      if (type === "dropoff") postcode = this.dropoff;
      if (!postcode) return this.warningAlert("Enter an address");
      var loader = this.loadingDots("lightgreen");
      this.$store
        .dispatch("onemapAddress", postcode)
        .then((res) => {
          console.log("onemapAddress", res.data);
          if (res.data.found < 1) {
            alert(`No onemap address results for [ ${postcode} ]`);
            return;
          }
          var address = res.data.results[0]; // first result
          this.$swal({
            title: postcode,
            html: `<div style="text-align:left">
            Address:<br><strong>${address.ADDRESS}</strong><br><br>
            Street:<br><strong>${address.ROAD_NAME}</strong>
            </div>`,
          });
          var obj = {
            postcode: postcode,
            street: address.ROAD_NAME,
            address: address.ADDRESS,
            lat: address.LATITUDE,
            lon: address.LONGITUDE,
          };
          if (type === "pickup") this.pickupAddress = obj;
          else this.dropoffAddress = obj;
        })
        .catch((err) => this.apiError(err))
        .finally(() => loader.hide());
    },
    circuitBreakerLink() {
      var user = this.userID(); // send notification back to this user
      var country = "sg";
      var url = `/cb/${this.phoneNumber}?created_by=${user}&offer=${this.offer}&p_postcode=${this.pickup}&d_postcode=${this.dropoff}&time=${this.time}&country=${country}`;
      return url;
    },
    shortLink() {
      var url = process.env.VUE_APP_HOST;
      return `${url}/q/${this.link}`;
    },
    shortLinkMessage() {
      var link = this.shortLink();
      return `${this.shareMessage()} ${link}`;
    },
    submit() {
      var longLink = this.circuitBreakerLink();
      this.shortenLink(longLink, this.link, 24 * 60); // 24 hours validity
      var link = this.shortLink();
      this.$swal({
        title: "Paste to share 🥳",
        html: `<strong><i class="fa fa-receipt"></i> #12</strong>&nbsp;-
        Job share link<br>copied to clipboard!<br><br><a href='${link}' target='_blank'>${link}</a>`,
        showConfirmButton: true,
        confirmButtonText: "<i class='fa fa-share-alt'></i> Share",
        confirmButtonColor: this.bulmaColor("primary"),
      }).then((val) => {
        console.log("sendOrder", val);
        if (val.value) this.shareOrder();
      });
    },
    shareOrder() {
      if (!navigator.share) {
        console.log("native sharing not supported by this device");
        var txt = `Sharing not supported by this device.<br><br>Paste into a chat.`;
        this.warningAlert(txt);
        return;
      }
      navigator
        .share({
          text: this.shareMessage(),
          url: this.shortLink(),
        })
        .then(() => console.log("Successful share"))
        .catch((err) => console.log("Error sharing", err));
    },
  },
};
</script>

<style scoped>
.notification {
  padding: 1rem;
}
.field-name {
  width: 100px;
}
.single-line {
  white-space: nowrap;
  overflow: auto;
  margin-bottom: -10px;
  display: inline-block;
}
</style>